<template>
  <div id="warehouseLayout" :class="['user-layout-wrapper', device]">
    <div class="content-box">
      <user-menu class="user-menu"></user-menu>
    </div>
    <div class="container">

      <route-view></route-view>

      <div class="footer">
        <div class="copyright">
          Copyright &copy MegaTechnology
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RouteView from './RouteView'
import { mixinDevice } from '@/utils/mixin'
import UserMenu from '@/components/tools/UserMenu'

export default {
  name: 'WarehouseLayout',
  components: { RouteView, UserMenu },
  mixins: [mixinDevice],
  data() {
    return {}
  },
  mounted() {
    document.body.classList.add('warehouseLayout')
  },
  beforeDestroy() {
    document.body.classList.remove('warehouseLayout')
  }
}
</script>

<style lang="less" scoped>
@import '../components/index.less';

#warehouseLayout.user-layout-wrapper {
  height: 100%;

  &.mobile {
    .container {
      .main {
        max-width: 368px;
        width: 98%;
      }
    }
  }

  .user-menu /deep/ .content-box {
    font-size: 16px;
    position: absolute;
    width: 20%;
    top: 0;
    right: 30px;
    text-align: right;
    margin: 20px 20px;
    z-index: @ant-global-header-zindex;
    transition: all 0.25s ease;
    display: flex;
    flex: 1 0 auto;
    height: 64px;
    align-content: center;
    justify-content: space-around;
    float: right;
  }

  .container {
    width: 100%;
    min-height: 100%;
    background-color: #406292;
    /*background-image: url(~@/assets/login.svg),url(~@/assets/logo.svg);*/
    background-position: 0 70px, 30px 2px;
    background-repeat: no-repeat, no-repeat;
    background-size: 100%, 10%;
    padding: 130px 0 10px;
    position: relative;

    a {
      text-decoration: none;
    }

    .top {
      text-align: center;

      .header {
        height: 44px;
        line-height: 20px;

        .badge {
          position: absolute;
          display: inline-block;
          line-height: 1;
          vertical-align: middle;
          margin-left: -12px;
          margin-top: -4px;
          opacity: 0.8;
        }

        /*.title {*/
        /*font-size: 33px;*/
        /*!*color: rgba(0, 0, 0, .85);*!*/
        /*color: #1890ff;*/
        /*font-family: Avenir, 'Helvetica Neue', Arial, Helvetica, sans-serif;*/
        /*font-weight: 600;*/
        /*position: relative;*/
        /*top: 0;*/
        /*}*/
      }

      .desc {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.45);
        margin-top: 12px;
        margin-bottom: 40px;
      }
    }

    .main {
      min-width: 260px;
      width: 400px;
      height: 450px;
      margin: 0 auto;
      background: rgba(0, 0, 0, 0.4);
    }

    .footer {
      position: absolute;
      width: 100%;
      bottom: 0;
      padding: 0 16px;
      margin: 24px 0 24px;
      text-align: center;

      .links {
        margin-bottom: 8px;
        font-size: 14px;

        a {
          color: rgba(0, 0, 0, 0.45);
          transition: all 0.3s;

          &:not(:last-child) {
            margin-right: 40px;
          }
        }
      }

      .copyright {
        color: rgba(0, 0, 0, 0.45);
        font-size: 14px;
      }
    }
  }

  .logo {
    height: 70px;
    margin: 5px 20px 20px 20px;
    border-style: none;
    text-align: left;
    position: relative;
    left: 5px;
    top: 20px;
  }
}
</style>
